import { QueryClient, useQuery } from "react-query"
import { getEventFormSubmission, getEventLatestFormSubmissions, getEventFormSubmissions } from "api/forms"
import { FormSubmissionSortOption } from "sharedTypes"

export const eventFormSubmissionsCacheKey = (eventId: string, page?: number, sort?: FormSubmissionSortOption, formIds?: string[], types?: string[]) => ["eventFormSubmissions", eventId, page, sort, formIds, types]
export const eventFormSubmissionCacheKey = (submissionId: string) => ["eventFormSubmission", submissionId]

export const useEventFormSubmissionsPaginated = (
  eventId: string,
  page: number,
  sort?: FormSubmissionSortOption,
  formIds?: string[],
  statuses?: string[],
  { enabled = true }: { enabled?: boolean } = {},
) => {
  const query = useQuery(
    eventFormSubmissionsCacheKey(eventId, page, sort, formIds, statuses),
    () => getEventFormSubmissions(eventId, page, { sort, formIds, statuses })
      .then(({ data }) => data),
    { keepPreviousData: true, enabled },
  )

  return query
}

export const useEventLatestFormSubmissions = (eventId: string, count: number) => useQuery(
  ["eventFormSubmissions", eventId, "latest", count],
  () => getEventLatestFormSubmissions(eventId, count).then(({ data }) => data),
)

const fetchEventFormSubmission = (eventId: string, submissionId: string) => (
  getEventFormSubmission(eventId, submissionId).then(({ data }) => data)
)

export const useEventFormSubmission = (eventId: string, submissionId: string) => useQuery(
  eventFormSubmissionCacheKey(submissionId),
  () => fetchEventFormSubmission(eventId, submissionId),
  { enabled: Boolean(submissionId) },
)

export const prefetchEventFormSubmission = (
  queryClient: QueryClient, eventId: string, submissionId: string,
) => queryClient.prefetchQuery(
  eventFormSubmissionCacheKey(submissionId),
  () => fetchEventFormSubmission(eventId, submissionId),
  { staleTime: 30_000 },
)
